angular
    .module('webcomm')
    .factory('timeFormattingService', function () {
        return {
            formatFeedDate: function (date) {
                if (!(date instanceof Date))
                    throw "date must be a Date object";

                var hours = date.getHours();
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ampm;

                var days = ["Sun","Mon","Tue","Wed","Thur","Fri","Sat"];
                
                return days[date.getDay()] + ' ' + strTime;
            },
            
            formatLocationDate: function(fromDate) {
                let year = fromDate.getUTCFullYear();
                // note : getUTCMonth 0(Jan)-11(Dec)
                let month = fromDate.getUTCMonth() < 9 ? '0' + (fromDate.getUTCMonth()+1) : fromDate.getUTCMonth()+1;
                let day = fromDate.getUTCDate() < 10 ? '0' + fromDate.getUTCDate() : fromDate.getUTCDate(); 
                let hour = fromDate.getUTCHours() < 10 ? '0' + fromDate.getUTCHours() : fromDate.getUTCHours(); 
                let minute = fromDate.getUTCMinutes() < 10 ? '0' + fromDate.getUTCMinutes() : fromDate.getUTCMinutes(); 
                let second = fromDate.getUTCSeconds() < 10 ? '0' + fromDate.getUTCSeconds() : fromDate.getUTCSeconds();
                return `${year}${month}${day}${hour}${minute}${second}`;
            }
        }
    });